import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

/**
 * 없는 주소 화면. 서버도 같은 주소에 404 + X-Robots-Tag 를 주지만, 화면 안 이동(클라이언트 라우팅)으로 들어온
 * 경우를 위해 robots noindex 메타를 붙인다(이 화면을 떠나면 Helmet 이 지운다).
 */
export default function NotFoundPage() {
  return (
    <main className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
      <Helmet>
        <title>페이지를 찾을 수 없습니다 | 채권도시 법률사무소</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <p className="text-5xl font-bold text-gray-300">404</p>
      <h1 className="mt-4 text-xl font-semibold">페이지를 찾을 수 없습니다</h1>
      <p className="mt-2 text-gray-500">주소가 바뀌었거나 없어진 페이지입니다.</p>
      <Link to="/" className="mt-6 underline">
        홈으로 가기
      </Link>
    </main>
  );
}
